import pluralize from 'pluralize'
import ApiClient from '@softwaredev_cegeka/api-client'
import serializeParamsWithoutBrackets from '@softwaredev_cegeka/api-client/dist/utils/axios/serializeParamsWithoutBrackets'
import objectFilterMapper from 'src/api/filterMappers/ObjectFilterMapper'

export const EVENT = 'event'

class EventsApi extends ApiClient {
    static BASE_URL = '/api/events'
    static FILTER_MAPPERS = [objectFilterMapper]
    constructor(timeout) {
        super(timeout)
        this.client.defaults.paramsSerializer = {
            serialize: serializeParamsWithoutBrackets,
        }
    }
    /**
     * @param data
     * @param [cancelId]
     * @returns {Promise<AxiosResponse<T>>}
     */
    search = function (data, cancelId = null) {
        const { filters, page = 1, per_page = 50, ...rest } = data
        return this.client.post(
            '/search',
            {
                page: page,
                per_page: per_page,
                query: filters.query,
                term: filters.term,
                ...rest,
            },
            {
                cancelId: cancelId ?? this.cancelId,
            }
        )
    }

    fetchFilterValues(data, entity, field, input, limit = 10, cancelId = null) {
        // We pluralize the passed entity as it the endpoint expects it to be plural
        return this.client.post(
            `/${pluralize(entity)}/options/${field}`,
            data,
            {
                timeout: 30000,
                params: {
                    limit,
                    value_like: input,
                },
                cancelId: cancelId ?? this.cancelId,
            }
        )
    }

    fetchEvents = function (queryParams, cancelId) {
        return this.client.get('/events', {
            params: {
                page: 1,
                per_page: 10,
                ...queryParams,
            },
            cancelId: cancelId,
        })
    }

    fetchEventImpactedDevices = function (event_id, cancelId) {
        return this.client.get(`/events/${event_id}/impacted_entities`, {
            params: {
                page: 1,
                per_page: 10,
            },
            cancelId: cancelId,
        })
    }

    clearEvent({ eventUid, ...params }, cancelId) {
        if (!eventUid) {
            return Promise.reject('Please provide an eventUid')
        }
        return this.client.patch(`/events/${eventUid}/clear`, params, {
            timeout: 30000,
            cancelId,
        })
    }

    startExport(params, cancelId = null) {
        const { filters, page = 1, per_page = 50, ...rest } = params
        return this.client.post(
            `/events/export`,
            {
                page: page,
                per_page: per_page,
                query: filters.query,
                term: filters.term,
                ...rest,
            },
            {
                cancelId: cancelId,
            }
        )
    }

    /**
     * @param {Object} params
     * @param {Object} params.filter
     * @param {int} params.per_page
     * @param {int} params.page
     * @param {Symbol} [cancelId]
     * @returns {*}
     */
    fetchExportHistory(params, cancelId = null) {
        const { page = 1, per_page = 50, filter, ...rest } = params
        return this.client.get('/documents/export-history', {
            params: {
                page: page,
                per_page: per_page,
                cancelId: cancelId,
                filter: this.mapFilter(filter),
                ...rest,
            },
        })
    }
}

function isEventClearable(event) {
    // The DB has a default of 0, but due to the ORM this turns into 1970-01-01T00:00:00 on the endpoint.
    const isClosed = !!new Date(event?.closed_timestamp).getTime() ?? false
    return !isClosed && event?.status !== 'Cleared'
}

export { EventsApi, isEventClearable }
